/**
 * @description: 花单明细报表
 * @author: lyr
*/
<template>
    <div class="flower-detail-report">
        <div class="list" v-show="!showGroupPanel">
            <el-form :inline="true" size="small" :model="list_form">
                <el-form-item label="开房时间">
                    <div class="clearfix" ref="list_date">
                        <el-col :span="11">
                            <el-input placeholder="开始时间" v-model="list_form.start_time"></el-input>
                        </el-col>
                        <el-col class="el-line" :span="2">-</el-col>
                        <el-col :span="11">
                            <el-input placeholder="结束时间" v-model="list_form.end_time"></el-input>
                        </el-col>
                    </div>
                </el-form-item>
                <el-form-item label="门店">
                    <el-select v-model="list_form.shop_id" filterable placeholder="请选择门店" @change="changeShop($event)">
                        <el-option v-for="item in shop_list" :key="item.id" :label="item.name"
                            :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="包厢">
                    <el-select v-model="list_form.room_id" filterable clearable placeholder="请选择包厢"
                        :disabled="list_form.shop_id==''">
                        <el-option v-for="item in room_list" :key="item.id" :label="item.name"
                            :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="账单号">
                    <el-input placeholder="请输入账单号" clearable v-model="list_form.bill_no"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input placeholder="请输入员工姓名/艺名" v-model="list_form.present_name">
                        <el-select class="el-slot-select" v-model="list_form.present_type" slot="prepend"
                            placeholder="请选择" @change="onPresentTypeChange($event)">
                            <el-option label="全部" value="0"></el-option>
                            <el-option label="员工" value="1"></el-option>
                            <el-option label="艺人" value="2"></el-option>
                        </el-select>
                    </el-input>
                </el-form-item>
                <el-form-item label="组别">
                    <el-input placeholder="请选择组别" v-model="group_for_show" readonly :disabled="groupDisabled"
                        @click.native="openGroupPanel"></el-input>
                </el-form-item>
                <el-form-item label="工号">
                    <el-input placeholder="请输入员工号/腰牌号" clearable v-model="list_form.present_work_number"></el-input>
                </el-form-item>
                <el-form-item label="花单号">
                    <el-input placeholder="请输入花单号" clearable v-model="list_form.order_id"></el-input>
                </el-form-item>
                <el-form-item label="操作人">
                    <el-select v-model="list_form.admin_id" filterable clearable placeholder="请选择下单操作人">
                        <el-option v-for="item in staff_list" :key="item.id" :label="item.name"
                            :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="操作类型">
                    <el-select v-model="list_form.type" filterable clearable placeholder="请选择操作类型">
                        <el-option label="全部" value="0"></el-option>
                        <el-option label="送花" value="1"></el-option>
                        <el-option label="退花" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="付款方式">
                    <el-select v-model="list_form.pay_platform" filterable clearable placeholder="请选择付款方式">
                        <el-option v-for="item in pay_platform" :key="item.id" :label="item.name"
                            :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="包厢区域">
                    <el-input placeholder="请选择包厢区域" v-model="room_area_str" readonly
                        @click.native="openRoomAreaPop"></el-input>
                </el-form-item>
                <el-form-item label="花名">
                    <el-input placeholder="请输入花名" clearable v-model="list_form.flower_name"></el-input>
                </el-form-item>
                <el-form-item label="付款状态">
                    <el-select v-model="list_form.status" filterable placeholder="请选择付款状态">
                        <el-option label="全部" value="0"></el-option>
                        <el-option label="已支付" value="1"></el-option>
                        <el-option label="未支付" value="-1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="listQuery">查询</el-button>
                    <el-button @click="listExport">导出</el-button>
                </el-form-item>
            </el-form>
            <div class="total-txt">
                <div class="item">数量合计：{{quantity}}</div>
                <div class="item">金额合计：{{actual_pay_total}}</div>
                <div class="item">已付款金额：{{ pay_total }}</div>
                <div class="item">未付款金额：{{ un_pay_total }}</div>
            </div>
            <el-table v-loading="loading" element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)" :data="list_table">
                <el-table-column prop="start_time" label="开房时间" width="150"></el-table-column>
                <el-table-column prop="room_area_name" label="包厢区域"></el-table-column>
                <el-table-column prop="room_name" label="包厢号"></el-table-column>
                <el-table-column prop="bill_no" label="账单号"></el-table-column>
                <el-table-column prop="order_id" label="花单号"></el-table-column>
                <el-table-column prop="present_group_name" label="组别"></el-table-column>
                <el-table-column prop="present_name" label="员工"></el-table-column>
                <el-table-column prop="present_work_number" label="工号/腰牌号"></el-table-column>
                <el-table-column prop="flower_name" label="花名"></el-table-column>
                <el-table-column prop="quantity" label="数量"></el-table-column>
                <el-table-column prop="discount_price" label="单价"></el-table-column>
                <el-table-column prop="actual_pay_total" label="金额"></el-table-column>
                <el-table-column prop="admin_name" label="操作人"></el-table-column>
                <el-table-column prop="create_time" label="操作时间"></el-table-column>
                <el-table-column prop="type_name" label="操作类型"></el-table-column>
                <el-table-column prop="status_name" label="付款状态"></el-table-column>
                <el-table-column prop="pay_platform_show" label="付款方式"></el-table-column>
            </el-table>
            <el-pagination background layout="total, prev, pager, next, jumper" :page-size="GLOBAL.PAGESIZE"
                :current-page.sync="list_page" :total="list_total" @current-change="getList">
            </el-pagination>
        </div>
        <!-- 组别选择页面 -->
        <div class="group-panel" v-show="showGroupPanel">
            <h3>请选择组别</h3>
            <el-input placeholder="请输入组别名称" v-model="group_name" class="group-name">
                <el-button slot="append" icon="el-icon-search" @click="getGroup"></el-button>
            </el-input>
            <div class="checkbox-wrapper">
                <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll"
                    @change="handleCheckAllChange">全选</el-checkbox>
                <el-checkbox-group v-model="list_form.present_group_ids" @change="handleCheckedGroupChange">
                    <el-checkbox v-for="item in group" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
                </el-checkbox-group>
            </div>
            <el-button @click="toList">取消</el-button>
            <el-button type="primary" @click="commitGroup">确定</el-button>
        </div>
        <!-- 包厢区域选择 -->
        <div class="room-area-pop" ref="room_area_pop">
            <div class="checkbox-wrapper">
                <el-checkbox v-model="checkAllRoomArea" @change="handleCheckAllRoomAreaChange">全选</el-checkbox>
                <el-checkbox-group v-model="list_form.room_area" @change="handleCheckRoomAreaChange">
                    <el-checkbox v-for="item in room_area_list" :label="item.id"
                        :key="item.id">{{item.name}}</el-checkbox>
                </el-checkbox-group>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: 'flower-detail-report',
        data() {
            return {
                loading: false,
                shop_list: [],
                room_area_list: [],
                room_list: [],
                group: [],
                staff_list: [],
                pay_platform: [],
                groupDisabled: true,
                showGroupPanel: false,
                group_name: '',
                isIndeterminate: true,
                checkAll: false,
                checkAllRoomArea: false,
                list_form: {
                    start_time: '',
                    end_time: '',
                    shop_id: '',
                    room_id: '',
                    bill_no: '',
                    present_type: '0', //0全部 1员工 2艺人
                    present_name: '',
                    present_group_ids: [], // 组别
                    present_work_number: '', // 工号
                    order_id: '',
                    admin_id: '',
                    type: '0', // 0全部 1送花 2退花
                    pay_platform: '',
                    room_area: [],
                    flower_name: '',
                    status: '0', // 0全部 1已支付 2未支付
				},
				list_table: [],
				list_page: 1,
                list_total: 0,
                quantity: 0, // 数量合计
                actual_pay_total: 0, // 金额合计
                pay_total: 0, // 支付金额合计
                un_pay_total: 0, // 未支付金额合计
            }
        },
        computed: {
            group_for_show() {
                if (this.list_form.present_group_ids.length == 0) {
                    return ''
                }else {
                    let res = []
                    this.list_form.present_group_ids.forEach(v => {
                        this.group.forEach(item => {
                            if (item.id == v) {
                                res.push(item.name)
                            }
                        })
                    })
                    return res.join(',')
                }
            },
            room_area_str() {
                if (this.list_form.room_area.length == 0) {
                    return ''
                }else if(this.list_form.room_area.length == this.room_area_list.length) {
                    return '全部'
                }else {
                    let res = []
                    this.list_form.room_area.forEach(v => {
                        this.room_area_list.forEach(item => {
                            if (item.id == v) {
                                res.push(item.name)
                            }
                        })
                    })
                    return res.join(',')
                }
            },
        },
        mounted: function() {
            // 日期
            this.list_form.start_time = moment().format('YYYY-MM-DD 08:00');
            this.list_form.end_time = moment().add(1, 'day').format('YYYY-MM-DD 08:00');
            this.innitDate();
            new Promise(resolve => {
                this.getShop(resolve)
            }).then(res => {
                this.list_form.shop_id = this.shop_list[0].id;
                this.getRoomArea(this.list_form.shop_id)
                this.getRoom(this.list_form.shop_id)
                this.getStaffList(this.list_form.shop_id)
                this.getPayType(this.list_form.shop_id)
                this.setShopDefaultTime(this.list_form.shop_id)
                this.getList(1);
            })
        },
        methods: {
            setShopDefaultTime(shop_id) {
                let report_default_time = '1'
                let shop_report_default_time = this.$store.state.shop_report_default_time
                shop_report_default_time.forEach(item => {
                    if (shop_id == item.shop_id) {
                        report_default_time = item.report_default_time
                        if (report_default_time == '1') {
                            this.list_form.start_time = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.list_form.end_time = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }else {
                            this.list_form.start_time = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.list_form.end_time = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }
                    }
                })
            },
            // 初始化日期插件
            innitDate: function() {
                const _this = this;
                $(_this.$refs.list_date).daterangepicker({
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().toDate(),
                    endDate: moment().add(1, 'day').toDate(),
                }, function(start, end, label) {
                    _this.list_form.start_time = start.format('YYYY-MM-DD 08:00');
                    _this.list_form.end_time = end.format('YYYY-MM-DD 08:00');
                });
            },
            // 初始化门店输入框
            getShop: function(resolve) {
                const _this = this;

                Vue.axios.post('PublicData/api_getShopListByPurview', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.shop_list = res.data.response.result;
                        _this.shop_list.shift();
                        resolve()
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            // 获取员工
            getStaffList: function(shop_id) {
                const _this = this;

                Vue.axios.post('user/getSearchList', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.staff_list = res.data.response.result;
                        _this.staff_list.unshift({
                            id: '',
                            name: '全部'
                        });
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            // 获取支付类型
            getPayType: function(shop_id) {
                const _this = this;

                Vue.axios.post('Order/getAllPayPlatform', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        let arr = [{id: '', name: '全部'}];
                        for(let [key, value] of Object.entries(res.data.response.data)) {
                            arr.push({id: key, name: value});
                        }
                        _this.pay_platform = arr
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            // 获取包厢号
            getRoom: function(shop_id) {
                const _this = this;
                Vue.axios.post('Shop/getAllRoom', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.room_list = res.data.response.result;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            // 获取组别
            getGroup: function() {
                let _this = this;
                let key_word = this.list_form.present_type == '1' ? 'user' : this.list_form.present_type == '2' ? 'personnel' : ''
                Vue.axios.post('FinanceReport/getGroupSearchList', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": '0',
                            "page_size": '0',
                            "shop_id": _this.shop_id,
                            "key_word": key_word,
                            "group_name": _this.group_name
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        let arr = [];
                        res.data.response.result.forEach(v => {
                            arr.push({
                                id: v.group_id,
                                name: v.group_name
                            })
                        })
                        _this.group = arr
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            onPresentTypeChange(val) {
                this.list_form.present_group_ids = []
                if (val == '1' || val == '2') {
                    this.groupDisabled = false
                }else {
                    this.groupDisabled = true
                }
            },

            getList(page) {
				const _this = this;

				_this.loading = true;
				Vue.axios.post('Flower/getLogList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
							"page_size": _this.GLOBAL.PAGESIZE,
                            "start_time": _this.list_form.start_time,
                            "end_time": _this.list_form.end_time,
							"shop_id": _this.list_form.shop_id,
							"room_id": _this.list_form.room_id,
                            "bill_no": _this.list_form.bill_no,
                            "present_type": _this.list_form.present_type, //0全部 1员工 2艺人
                            "present_name": _this.list_form.present_name,
                            "present_group_ids": _this.list_form.present_group_ids, // 组别
                            "present_work_number": _this.list_form.present_work_number, // 工号
                            "order_id": _this.list_form.order_id,
                            "admin_id": _this.list_form.admin_id,
                            "type": _this.list_form.type, // 0全部 1送花 2退花
                            "pay_platform": _this.list_form.pay_platform,
                            "room_area": _this.list_form.room_area,
                            "flower_name": _this.list_form.flower_name,
                            "status": _this.list_form.status
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.list_total = Number(res.data.response.result.total)
                            _this.quantity = res.data.response.result.quantity
                            _this.actual_pay_total = res.data.response.result.actual_pay_total
                            _this.pay_total = res.data.response.result.pay_total
                            _this.un_pay_total = res.data.response.result.un_pay_total
						}
						_this.list_table = res.data.response.result.rows;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},

            changeShop(val) {
                this.list_form.shop_id = val
                if (!!val) {
                    this.getStaffList(val)
                    this.getRoom(val)
                    this.getPayType(val)
                    this.getRoomArea(val)
                    this.list_form.present_type = '0'
                    this.present_group_ids = []
                    this.setShopDefaultTime(val)
                }
            },

            // 打开组别选择列表
            openGroupPanel() {
                if (this.list_form.present_type != '0') {
                    this.group_name = ''
                    this.isIndeterminate = true
                    this.checkAll = false
                    this.getGroup()
                    this.showGroupPanel = true
                }
            },

            // 全选
            handleCheckAllChange(val) {
                if (val) {
                    this.list_form.present_group_ids = []
                    this.group.forEach(v => {
                        this.list_form.present_group_ids.push(v.id)
                    })
                }else {
                    this.list_form.present_group_ids = []
                }

                this.isIndeterminate = false                 
            },

            // 选择组别
            handleCheckedGroupChange(val) {
                let len = val.length
                this.checkAll = len === this.group.length
                this.isIndeterminate = len > 0 && len  <  this.group.length
            },

            toList() {
                this.showGroupPanel = false
            },

            // 确定选择组别
            commitGroup() {
                this.showGroupPanel = false
            },

            // 获取包厢区域
            getRoomArea: function(shop_id) {
                const _this = this;
                Vue.axios.post('Shop/getRoomArea', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.room_area_list = res.data.response.result;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            // 打开包厢区域选择弹窗
            openRoomAreaPop() {
                let _this = this
                let c_area_ids = _this.list_form.area_ids
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['选择包厢区域', true],
                    area: ['450px', ''], // 宽高
                    content: $(_this.$refs.room_area_pop),
                    cancel: function() {
                        _this.list_form.area_ids = c_area_ids
                    }
                }, function() {
                    layer.closeAll()
                }, function() {
                    _this.list_form.area_ids = c_area_ids
                    layer.closeAll()
                });
            },

            // 包厢区域全选
            handleCheckAllRoomAreaChange(val) {
                this.list_form.room_area = []
                this.checkAllRoomArea = val
                if (val) {
                    this.room_area_list.forEach(item => {
                        this.list_form.room_area.push(item.id)
                    })
                }
            },

            // 选择包厢区域
            handleCheckRoomAreaChange(val) {
                this.checkAllRoomArea = val.length === this.room_area_list.length
            },

			// 查询
			listQuery() {
                this.list_page = 1
				this.getList(this.list_page);
            },
            
            listExport: function() {
                window.location.href = Vue.ctUrl + "Flower/exportLogList" +
                    "?start_time=" + this.list_form.start_time +
                    "&end_time=" + this.list_form.end_time +
                    "&shop_id=" + this.list_form.shop_id +
                    "&room_id=" + this.list_form.room_id +
                    "&bill_no="+ this.list_form.bill_no +
                    "&present_type=" + this.list_form.present_type +
                    "&present_name=" + this.list_form.present_name +
                    "&present_group_ids=" + this.list_form.present_group_ids +
                    "&present_work_number=" + this.list_form.present_work_number +
                    "&order_id=" + this.list_form.order_id +
                    "&admin_id=" + this.list_form.admin_id +
                    "&type=" + this.list_form.type +
                    "&pay_platform=" + this.list_form.pay_platform +
                    "&room_area=" + this.list_form.room_area +
                    "&flower_name=" + this.list_form.flower_name +
                    "&status=" + this.list_form.status;
                layer.msg("导出成功！");
            },
        }
    }
</script>
<style lang="less" scoped>
    .group-panel {
        .group-name {
            width: 300px;
            margin: 20px 0;
        }
        .checkbox-wrapper {
            width: 700px;
            margin-bottom: 20px;
            .el-checkbox {
                width: 200px;
                margin: 10px;
            }
        }
    }
    .room-area-pop {
        display: none;
        .el-checkbox {
            width: 150px;
            margin-bottom: 10px;
            margin-right: 10px;
        }
    }
    .total-txt {
        margin-bottom: 10px;
        display: flex;
        flex-direction: row;
        align-items: center;
        .item {
            margin-right: 40px;
        }
    }
</style>